import { useEffect,useState } from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import { post } from '../../utils/axios'

const AboutUs = () => {

    const [content,setContent] = useState('')

    useEffect(() => {
        const postedData = {
            key: 'about'
        }
        post('Config/GetConfigByKey',postedData).then(({ data }) => {
            if(data.isSuccess)
                setContent(data.data.value)
        })
    },[])

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">درباره ما</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%',mb: 5 }} className="business-item">
                    <CardContent style={{ paddingBottom: 16 }}>
                        <p className="others-page-content">{content}</p>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default AboutUs